module.exports = __webpack_public_path__ + "static/media/IT2735S.098cc6d1.png";